import { FieldValues } from 'react-hook-form'
import { FieldPath } from 'react-hook-form'
import { Controller, UseFormReturn } from 'react-hook-form'
import { Field, Input } from '@fluentui/react-components'
import React from 'react'


export type FormInputProps<FormVals extends FieldValues, Field extends FieldPath<FormVals>> = {
    label: string
    disabled?: boolean
    form: UseFormReturn<FormVals>
    required?: boolean
    field: Field,
    asInteger?: boolean

}

export function FormInput<
    FormVals extends FieldValues,
    Field extends FieldPath<FormVals>,
>({
      form,
      field,
      label,
      disabled,
      required,
      asInteger
  }: FormInputProps<FormVals, Field>) {
    return (
        <Controller
            name={field}
            rules={{
                required
            }}
            control={form.control}
            render={({ field: { value, onChange, disabled: _disabled, ref } }) => {

                return <Field label={label}>
                    <Input value={value ?? ''}
                           type={asInteger ? 'number' : undefined}
                           ref={ref}
                           disabled={disabled || _disabled}
                           onChange={e => {
                               if (asInteger) {
                                   e = {
                                       ...e,
                                       target: {
                                           ...e.target,
                                           value: parseInt(e.target.value) as any
                                       }
                                   }
                               }
                               onChange(e)
                           }} />
                </Field>
            }
            }
        />
    )
}
